import React from 'react'
import { Info } from 'media/icons'
import styled from 'styled-components'

const InfoBoxWrap = styled.div`
	display: flex;
	width: 300px;
	min-height: 50px;
	padding: 10px 16px 10px 48px;
	align-items: flex-start;
	border-radius: 4px;
	background: #E5F6FD;
	position: relative;
	font-size: 14px;
	font-weight: 400;
	color: #014361;
	svg {
		position: absolute;
		top: 10px;
		left: 16px;
	}
	g {
		fill: #0288D1;
	}

`
const InfoBox = ({ text }) => {
	return (
		<InfoBoxWrap>
			<Info/>
			{text}
		</InfoBoxWrap>
	)
}

export default InfoBox
